<template>
  <section>
    <div class="role">
      <div class="roleRight">
        <div class="roleRight_Top">
          <template v-if="searchShow">
            <el-input
                clearable
                v-model="search.searchKey"
                clas="input_search"
                placeholder="搜索关键字"
                @keyup.enter.native="SearchServiceList"
            ></el-input>
            <el-select
                v-model="search.channelAccountId"
                clearable
                filterable
                placeholder="渠道账号"
            >
              <el-option
                  v-for="item in channelList"
                  :key="item.channelAccountId"
                  :label="`${item.channelTypeName}-${item.account}-${item.name}`"
                  :value="item.channelAccountId"
              ></el-option>
            </el-select>
            <el-select
                filterable
                v-model="search.orderStatus"
                clearable
                placeholder="状态"
            >
              <el-option
                  label="关闭"
                  :value="0"
              ></el-option>
              <el-option
                  label="待审核"
                  :value="5"
              ></el-option>
              <el-option
                  label="审核失败"
                  :value="11"
              ></el-option>
              <el-option
                  label="待付款"
                  :value="15"
              ></el-option>
              <el-option
                  label="充值成功"
                  :value="20"
              ></el-option>
              <el-option
                  label="充值失败"
                  :value="21"
              ></el-option>
            </el-select>
            <el-button size="medium" type="primary" @click="SearchServiceList"
            >查询
            </el-button
            >
          </template>
          <el-button v-if="addShow" size="medium" type="primary" @click="addHandleClick"
          >新增
          </el-button
          >
        </div>
        <div class="roleRight_Container public-table-data">
          <el-table
              :data="tableData"
              size="medium"
              border
              style="width: 100%"
              row-key="customerServiceId"
              v-loading="loading"
          >
            <el-table-column fixed label="序号" type="index" width="100">
              <template slot-scope="scope">
                <span @click="showDetails(scope.row)">{{
                    (page.pageNo - 1) * page.pageSize + scope.$index + 1
                  }}</span>
              </template>
            </el-table-column>
            <el-table-column prop="orderNumber" min-width="180" label="订单号">
              <template slot-scope="scope">
                <span @click="showDetails(scope.row)">{{ scope.row.orderNumber }}</span>
              </template>
            </el-table-column>
            <el-table-column prop="channelTypeName" label="渠道" min-width="160">
              <template slot-scope="scope">
                <span @click="showDetails(scope.row)">{{ scope.row.channelTypeName }}</span>
              </template>
            </el-table-column>
            <el-table-column prop="account" label="账号" min-width="160">
              <template slot-scope="scope">
                <span @click="showDetails(scope.row)">{{ scope.row.account }}</span>
              </template>
            </el-table-column>
            <el-table-column prop="code" label="标识" min-width="160">
              <template slot-scope="scope">
                <span @click="showDetails(scope.row)">{{ scope.row.code }}</span>
              </template>
            </el-table-column>
            <el-table-column prop="applyName" label="填写人" min-width="80">
              <template slot-scope="scope">
                <span @click="showDetails(scope.row)">{{ scope.row.applyName }}</span>
              </template>
            </el-table-column>
            <el-table-column prop="applyTime" label="填写时间" min-width="220">
              <template slot-scope="scope">
                <span @click="showDetails(scope.row)">{{ scope.row.applyTime }}</span>
              </template>
            </el-table-column>
            <el-table-column prop="bizUid" label="赔付币" min-width="100">
              <template slot-scope="scope">
                <span @click="showDetails(scope.row)">￥ {{ scope.row.money1 / 100}}</span>
              </template>
            </el-table-column>
            <el-table-column prop="rate" label="返点（%）" min-width="120">
              <template slot-scope="scope">
                <span @click="showDetails(scope.row)">{{ scope.row.rate }}</span>
              </template>
            </el-table-column>
            <el-table-column prop="money2" label="到账币" min-width="120">
              <template slot-scope="scope">
                <span @click="showDetails(scope.row)">{{ scope.row.money2 / 100}}</span>
              </template>
            </el-table-column>
            <el-table-column prop="orderStatusName" label="状态" min-width="120">
              <template slot-scope="scope">
                <span @click="showDetails(scope.row)">{{ scope.row.orderStatusName }}</span>
              </template>
            </el-table-column>
            <el-table-column prop="confirmName" label="确认人" min-width="120">
              <template slot-scope="scope">
                <span @click="showDetails(scope.row)">{{ scope.row.confirmName }}</span>
              </template>
            </el-table-column>
            <el-table-column prop="confirmTime" label="确认时间" min-width="120">
              <template slot-scope="scope">
                <span @click="showDetails(scope.row)">{{ scope.row.confirmTime }}</span>
              </template>
            </el-table-column>
            <el-table-column prop="moneyTime" label="赔付时间" min-width="120">
              <template slot-scope="scope">
                <span @click="showDetails(scope.row)">{{ scope.row.moneyTime }}</span>
              </template>
            </el-table-column>
            <el-table-column fixed="right" label="操作" min-width="240">
              <template slot-scope="scope">
                <el-button
                    size="mini"
                    v-if="scope.row.btn && scope.row.btn.audit"
                    @click="handleClick(scope.row)"
                    type="success"
                    style="margin-bottom: 5px"
                    plain
                >审核
                </el-button
                >
                <el-button
                    size="mini"
                    v-if="scope.row.btn && scope.row.btn.detail"
                    @click="showDetails(scope.row)"
                    type="success"
                    style="margin-bottom: 5px"
                    plain
                >详情
                </el-button
                >
                <el-button
                    size="mini"
                    v-if="scope.row.btn && scope.row.btn.confirm"
                    @click="handleClick(scope.row)"
                    type="success"
                    style="margin-bottom: 5px"
                    plain
                >确认
                </el-button
                >
                <el-button
                    v-if="scope.row.btn && scope.row.btn.close"
                    size="mini"
                    type="warning"
                    @click="handleDelete(scope.row)"
                    plain
                >撤销
                </el-button
                >
                <el-button
                    v-if="scope.row.btn && scope.row.btn.delete"
                    size="mini"
                    type="warning"
                    @click="handleRemove(scope.row)"
                    plain
                >删除
                </el-button
                >
              </template>
            </el-table-column>
          </el-table>
        </div>
        <div class="roleRight_pagenation">
          <el-pagination
              @size-change="handleSizeChange"
              @current-change="handleCurrentChange"
              :current-page="page.pageNo"
              :page-sizes="[PAGE_SIZE, 15, 20, 25]"
              :page-size="page.pageSize"
              layout="total, sizes, prev, pager, next, jumper"
              :total="page.count"
          >
          </el-pagination>
        </div>
      </div>
    </div>
    <!--新增-->
    <el-dialog
        title="赔付申请"
        :visible.sync="dialogVisible"
        :close-on-click-modal="false"
        width="500px"
        style="cursor: pointer"
        class="public-dialog"
    >
      <div class="public-dialog-form">
        <el-form
            ref="ruleForm"
            :rules="rules"
            :model="params"
            label-width="110px"
        >
          <el-row>
            <el-col :span="24">
              <el-form-item label="渠道账户：" prop="channelAccountId">
                <el-select
                    style="width: 100%;"
                    filterable
                    v-model="params.channelAccountId"
                    placeholder="请选择"
                >
                  <el-option
                      v-for="item in channelList"
                      :key="item.channelAccountId"
                      :label="`${item.channelTypeName}-${item.account}-${item.name}`"
                      :value="item.channelAccountId"
                  >
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="12">
              <el-form-item label="赔付币：" prop="money1">
                <el-input
                    type="number"
                    clearable
                    style="width: 100%;"
                    placeholder="赔付币"
                    v-model="params.money1"
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="返点（%）：" prop="money1">
                <el-input
                    type="number"
                    clearable
                    style="width: 100%;"
                    placeholder="返点（%）"
                    v-model="params.rate"
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="折算业绩：" prop="money1">
                <el-input
                    type="number"
                    clearable
                    style="width: 100%;"
                    placeholder="折算业绩"
                    v-model="params.money2"
                ></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="24">
              <el-form-item label="备注：">
                <el-input
                    clearable
                    :rows="4"
                    style="width: 100%;"
                    type="textarea"
                    placeholder="备注"
                    v-model="params.applyRemark"
                ></el-input>
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
      </div>
      <span slot="footer" class="public-dialog-footer">
        <el-button size="medium" @click="dialogVisible = false"
        >取 消</el-button
        >
    <el-button size="medium" type="primary" @click="handleEdit">确认</el-button>
      </span>
    </el-dialog>
    <!--详情-->
    <el-dialog
        title="渠道赔付"
        :visible.sync="detailsDialogVisible"
        :close-on-click-modal="false"
        width="800px"
        style="cursor: pointer"
        class="public-dialog"
    >
      <div class="public-dialog-form">
        <el-form
            ref="ruleForm"
            label-width="110px"
        >
          <el-row style="border-bottom: 1px solid rgba(0,0,0,0.1);margin-bottom: 20px">
            <el-col :span="12">
              <el-form-item label="订单号：">
                {{ detailsInfo.orderNumber }}
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="状态：">
                <el-tag>{{ detailsInfo.orderStatusName }}</el-tag>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="渠道账户：">
                {{ detailsInfo.account }} - ({{ detailsInfo.code }})
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="赔付币：">
                {{ detailsInfo.money1 / 100}}
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="返点（%）：">
                {{ detailsInfo.rate }}
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="折算业绩：">
                ￥ {{ detailsInfo.money2 / 100}}
              </el-form-item>
            </el-col>
          </el-row>
          <el-row style="border-bottom: 1px solid rgba(0,0,0,0.1);margin-bottom: 20px">
            <el-col :span="12">
              <el-form-item label="申请人：">
                {{ detailsInfo.applyName }} - ({{ detailsInfo.applyNumber }})
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="申请时间：">
                {{ detailsInfo.applyTime }}
              </el-form-item>
            </el-col>
            <el-col :span="24">
              <el-form-item label="申请备注：">
                {{ detailsInfo.applyRemark }}
              </el-form-item>
            </el-col>
          </el-row>
          <el-row v-if="detailsInfo.btn && detailsInfo.btn.confirm && !noShowTxt">
            <el-col :span="24">
              <el-form-item label="确认：">
                <el-radio v-model="examineParams.optStatus" :label="1">赔付成功</el-radio>
                <el-radio v-model="examineParams.optStatus" :label="0">赔付失败</el-radio>
              </el-form-item>
            </el-col>
            <el-col :span="24">
              <el-form-item label="备注：">
                <el-input
                    type="textarea"
                    :autosize="{ minRows: 2, maxRows: 4 }"
                    placeholder="备注"
                    v-model="examineParams.confirmRemark"
                >
                </el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row v-if="detailsInfo.orderStatus>=20"
                  style="border-bottom: 1px solid rgba(0,0,0,0.1);margin-bottom: 20px">
            <el-col :span="12">
              <el-form-item label="审核意见：">
                <el-tag>{{ detailsInfo.confirmStatusName }}</el-tag>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="审核备注：">
                {{ detailsInfo.confirmRemark }}
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
      </div>
      <span slot="footer" class="public-dialog-footer">
        <el-button size="medium" @click="detailsDialogVisible = false"
        >取 消</el-button
        >
        <el-button size="medium" v-if="detailsInfo.btn && detailsInfo.btn.confirm && !noShowTxt" type="primary"
                   @click="handleConfrimEdit">确 认</el-button>

      </span>
    </el-dialog>
  </section>
</template>
<script>
import {
  PAGE_SIZE,
  COMPLIANT_TIMETYPE
} from "@/config";

import {formatMaxNum, formatMinNum, emptyShow} from "@utils/tools/index";
import {isEmpty} from "../../utils/tools";

export default {
  data() {
    return {
      /* 函数 方法 */
      emptyShow, formatMaxNum, formatMinNum,
      /* 字段或数组 */
      PAGE_SIZE,
      COMPLIANT_TIMETYPE,
      channelList: [], //渠道类型list
      // 分页
      page: {
        pageNo: 1,
        pageSize: PAGE_SIZE,
      },

      tableData: [], //顶顶那列表

      loading: false,

      search: {
        orderType: 'pf'
      },

      searchShow: false,
      addShow: false,
      detailShow: false,
      revokeShow: false,

      dialogVisible: false,

      params: {},

      rules: {
        money1: [
          {required: true, message: "赔付币", trigger: "blur"},
        ],
        rate: [
          {required: true, message: "返点（%）", trigger: "blur"},
        ],
        money2: [
          {required: true, message: "折算业绩", trigger: "blur"},
        ],
        channelAccountId: [
          {required: true, message: "请选择投放渠道", trigger: "change"},
        ],
      }, //表单验证提示

      detailsDialogVisible: false,

      detailsInfo: {},

      examineParams: {},

      typeData: [],

      noShowTxt:false

    };
  },
  created() {
    this.maneyInfd();
    this.getserviceList();
    this.queryTypeTableData()
    this.getPermissionButtonList()
  },
  watch: {
    dialogVisible() {
      if (this.dialogVisible == false) {
        this.params = {};
      }
    },
    'params.rate'() {
      this.params.money2 = parseFloat(((this.params.money1) / (1 + (this.params.rate / 100)) ).toFixed(2))
    },
    'params.money1'() {
      this.params.money2 = parseFloat(((this.params.money1) / (1 + (this.params.rate / 100)) ).toFixed(2))
    },
  },
  methods: {
    /**
     * 获取类型列表
     */
    async queryTypeTableData() {
      this.loading = true;
      const {data: resData} = await this.$get("/bank/account/list?paging=false");
      this.loading = false;
      if (resData.result != 200) return;
      this.typeData = resData.data;
    },

    addHandleClick() {
      this.params = {
        money2:0,
        money1:0,
        rate:0
      };
      this.dialogVisible = true
    },
    async handleClick(row) {
      this.noShowTxt = false
      const {data: resData} = await this.$get(
          `/channel/order/info/${row.channelOrderId}`,
          {
            headers: {
              isLoading: true,
            },
          }
      );
      if (resData.result != 200) return;
      this.detailsInfo = resData.data;
      this.examineParams = {
        optStatus: 1
      }
      this.detailsDialogVisible = true;
    },
    //确认
    handleConfrimEdit() {
      if (!this.examineParams.optStatus) {
        if (!this.examineParams.confirmRemark) {
          this.$message.error('赔付失败状态，备注必填')
          return
        }
      }
      this.examineParams.channelOrderId = this.detailsInfo.channelOrderId
      this.$confirm("确认保存数据, 是否继续?", "提示", {
        type: "info",
      }).then(async () => {
        const {data: resData} = await this.$put(
            "/channel/order/confirm",
            this.examineParams,
            {
              headers: {
                isLoading: true,
              },
            }
        );
        if (resData.result != 200) return;
        this.getserviceList();
        this.detailsDialogVisible = false;
        this.$message.success("操作成功!");
        this.examineParams = JSON.parse(JSON.stringify({optStatus: 1}))
      })
    },

    async showDetails(row) {
      this.noShowTxt = true
      const {data: resData} = await this.$get(
          `/channel/order/info/${row.channelOrderId}`,
          {
            headers: {
              isLoading: true,
            },
          }
      );
      if (resData.result != 200) return;
      this.detailsInfo = resData.data;
      this.detailsDialogVisible = true;
    },
    //渠道充值申请提交
    handleEdit() {
      // this.params.orderType = 'pf'
      let money_one = ((this.params.money1) * 100).toFixed(2)
      let money_two = ((this.params.money2) * 100).toFixed(2)
      let obj = {
        orderType:'pf',
        channelAccountId:this.params.channelAccountId,
        money1:Number(money_one),
        rate:this.params.rate,
        money2:Number(money_two),
        applyRemark:this.params.applyRemark,
      }
      this.$confirm("确认保存数据, 是否继续?", "提示", {
        type: "info",
      }).then(async () => {
        const {data: resData} = await this.$post(
            "/channel/order/apply",
            obj,
            {
              headers: {
                isLoading: true,
              },
            }
        );
        if (resData.result != 200) return;
        this.getserviceList();
        this.dialogVisible = false;
        this.$message.success("添加成功!");
        this.params = JSON.parse(JSON.stringify({}))
      })
    },
    /**
     * 删除
     */
    handleRemove(row) {
      this.$confirm("此操作将删除当前数据, 是否继续?", "提示", {
        type: "warning",
      }).then(async () => {
        const {data: resData} = await this.$delete(
            `/channel/order/info/${row.channelOrderId}`,
            {
              headers: {
                isLoading: true,
              },
            }
        );
        if (resData.result != 200) return;
        this.getserviceList();
        this.$message.success("删除成功!");
      });
    },
    /**
     * 撤销
     */
    handleDelete(row) {
      let obj = {
        channelOrderId: row.channelOrderId,
        closeRemark: '撤销工单'
      }
      this.$confirm("此操作将撤销当前工单, 是否继续?", "提示", {
        type: "warning",
      }).then(async () => {
        const {data: resData} = await this.$put(
            `/channel/order/close`, obj,
            {
              headers: {
                isLoading: true,
              },
            }
        );
        if (resData.result != 200) return;
        this.getserviceList();
        this.$message.success("撤销成功!");
      });
    },
    async maneyInfd() {
      this.getChannelList()
    },
    //获取渠道 账号 类型
    async getChannelList() {
      const {data: orgData} = await this.$get(`/advertiser/channel/tf/list`);
      this.channelList = orgData.data;
    },
    //设置权限
    getPermissionButtonList() {
      let PermissionButtonList = window.sessionStorage.getItem('TaotanPermissionButton')
      let arr = JSON.parse(PermissionButtonList)
      if (arr.length) {
        arr.map(item => {
          if (item.code == 'finance:compensation:query') {
            this.searchShow = true
          }
          if (item.code == 'finance:compensation:add') {
            this.addShow = true
          }
        })
      }
    },
    //列表
    async getserviceList() {
      this.loading = true;
      const {data: res} = await this.$get(
          `/channel/order/list`,
          {params: {...this.search, ...this.page}},
          {
            headers: {
              isLoading: true,
            },
          }
      );
      this.loading = false;
      this.tableData = res.data;
      this.page.count = res.page.count;
      // console.log(res.data[0].channelOrderId)
      // this.handleClick(res.data[0])
    },
    //查询
    SearchServiceList() {
      this.page.pageNo = 1
      delete this.page['count']
      this.getserviceList()
    },
    //分页
    handleSizeChange(val) {
      this.page.pageSize = val;
      this.getserviceList();
    },
    handleCurrentChange(val) {
      this.page.pageNo = val;
      this.getserviceList();
    },
  },
};
</script>

<style lang="scss" scoped>
.role {
  display: flex;
  gap: 20px;
  color: #666; /** 公共的黑色 --暂定 */
  font-size: 14px;

  &Right {
    flex: 1;
    display: flex;
    overflow-x: hidden;
    flex-direction: column;

    &_Top {
      display: flex;
      gap: 15px;

      .el-input {
        width: auto;
      }

      .timeblock {
        display: flex;
        box-sizing: border-box;
        background: #fff;
        border: 1px solid #dcdfe6;
        border-radius: 5px;

        .cla ::v-deep .el-input--suffix .el-input__inner {
          padding-right: 0;
        }

        ::v-deep .el-input__inner {
          border: none !important;
          height: 38px;
        }
      }
    }

    &_Container {
      margin-top: 20px;
    }

    &_pagenation {
      margin: 40px auto;
    }

    ::v-deep .el-table th,
    ::v-deep .el-table td {
      text-align: center !important;
    }
  }
}

.fonts {
  font-size: 14px;
}

.topic-outer {
  width: 800px;
  background: #fff;
  overflow: hidden;
  margin-top: 20px;
  padding-bottom: 30px;
}

.flex-box {
  display: -webkit-box;
  display: -moz-box;
  display: -ms-flexbox;
  display: -webkit-flex;
  display: flex;
}

.fl1 {
  flex: 1;
  -webkit-flex: 1;
}

.glay {
  color: #8492a6;

  i {
    font-style: normal;
    color: #f56c6c;
  }
}

.pub-line {
  margin-bottom: 30px;
}

.congT_dis {
  display: flex;
  align-items: center;
}

.cell span {
  display: block;
  width: 100%;
  height: 100%;
  text-align: center;
  cursor: pointer;
}

</style>
